import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { XLg } from 'react-bootstrap-icons';

export default function Navbar(prop) {

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleButton = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <Link className="navbar-brand" to="#">Navbar</Link>
          <button className="navbar-toggler" onClick={toggleButton} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            {isExpanded ? <span><XLg /></span> : <span className="navbar-toggler-icon"></span>}
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="#">Home</Link>
              </li>
            </ul>
            <form className="d-flex">
              {prop.input}
              {/* <button className="btn btn-outline-success" type="submit">Search</button> */}
            </form>
          </div>
        </div>
      </nav>
    </div>
  )
}
